import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { TooltipModule } from 'primeng/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FileUploaderComponent } from './components/fileUploader/fileUploader.component';
import { FileSizePipe } from './customPipes/fileSize.pipe';
import { MomentFormatPipe } from './customPipes/momentFormat.pipe';
import { CastStatusPipe } from './customPipes/statusAlter.pipe';
import { PhoneFormatPipe } from './customPipes/phoneFormat.pipe';
import { DeletePopupComponent } from './components/delete-popup/delete-popup.component';
import { DialogModule } from 'primeng/dialog';
import { PermissionTreeComponent } from '../administration/user/components/permission-tree/permission-tree.component';
import { TreeModule } from 'primeng/tree';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CreateOrEditRoleModalComponent } from '../administration/roles/components/create-or-edit-role-modal.component';
import { FormlyCaseInputComponent } from './components/formlyComponents/formly-case-input/formly-case-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PositiveIntegerDirective } from './positiveInteger.directive';
import { AuthorizedDirective } from './authorized.directive';
import {
    constValidationMessage,
    exclusiveMaximumValidationMessage,
    exclusiveMinimumValidationMessage,
    maxItemsValidationMessage,
    maxLengthValidationMessage,
    maxValidationMessage,
    minItemsValidationMessage,
    minLengthValidationMessage,
    minValidationMessage,
    multipleOfValidationMessage,
    typeValidationMessage,
} from './formlyfunctions';
import { MultiSchemaTypeComponent } from './components/formlyComponents/multi-schema-type/multi-schema-type.component';
import { ArrayTypeComponent } from './components/formlyComponents/arraytype/arraytype.component';
import { FormlyInputComponent } from './components/formlyComponents/formly-input/formly-input.component';
import { FormlyJsonOutputComponent } from './components/formlyComponents/formly-json-output/formly-json-output.component';
// import { FormallySelectComponent } from './components/formlyComponents/formally-select/formally-select.component';
import { FormlyButtonComponent } from './components/formlyComponents/formly-button/formly-button.component';
import { FormlyFileInputComponent } from './components/formlyComponents/formly-file-input/formly-file-input.component';
import { FormlyImageOutputComponent } from './components/formlyComponents/formly-image-output/formly-image-output.component';
import { FormlyTextOutputComponent } from './components/formlyComponents/formly-text-output/formly-text-output.component';
import { FormlyTextareaComponent } from './components/formlyComponents/formly-textarea/formly-textarea.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MarkdownModule, MARKED_OPTIONS, ExtendedRenderer } from 'ngx-markdown';
import { AngularMarkdownEditorModule } from 'angular-markdown-editor';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyModule } from '@ngx-formly/core';
import { SeeMoreLessComponent } from './components/see-more-less/see-more-less.component';
import { TableModule } from 'primeng/table';
import { FormlyDatePickerComponent } from './components/formlyComponents/formly-date-picker/formlyDatePicker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TestingTableComponent } from './components/ob-table-Testing/ob-table-Testing.component';
import { JsonLogicEditorModule } from './components/testing-json-logic/json-logic-editor.module';
import { CreateEditLibraryComponent } from '../administration/components/Libraries/components/create-edit/create-edit.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { AccordionModule } from 'primeng/accordion';
import { FormlyTextInputComponent } from './components/formlyComponents/formly-text-input/formly-text-input.component';
import { FormlyCheckboxComponent } from './components/formlyComponents/formly-checkbox/formly-checkbox.component';
import { FormlyCustomTooltipComponent } from './components/formlyComponents/FormlyCustomTooltip/FormlyCustomTooltip.component';
import { OrganizationBlockedComponent } from './components/organization-blocked/organization-blocked.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TrimTextDirective } from './trimtext.directive';
import { ConfirmationDialogPopupComponent } from './components/confirmation-dialog-popup/confirmation-dialog-popup.component';
import { UnsavedChangesModalComponent } from './components/unsaved-changes-modal/unsaved-changes-modal.component';
import { TextAreaCanvasComponent } from './components/textAreaCanvas/textAreaCanvas.component';
import { GroupByPipe } from './customPipes/groupby.pipe';
import { SliderModule } from 'primeng/slider';
import { PublishCommentsComponent } from '../administration/components/template-history/publish-comments/publish-comments.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { TemplateChecklistListComponent } from '../administration/template-checklist/checklist-list/checklist-list.component';
import { SubscriptionWithErrorComponent } from './components/subscription-with-error/subscription-with-error.component';
import { PanelFieldWrapper } from './components/formlyComponents/formly-custom/formly-custom';
import { OpenbotsNgLibraryModule } from 'ob-ng-library';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxUploaderModule } from 'ngx-uploader';
import { MatDialogModule } from '@angular/material/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { ToastrModule } from 'ngx-toastr';
import { LazyImageDirective } from './lazy-image.directive';
import { StepsModule } from 'primeng/steps';
import { PanelMenuModule } from 'primeng/panelmenu'; // Import PanelMenuModule
import { UTCtoLocalTimeZonePipe } from './customPipes/utcto-local-time-zone.pipe';
import { AiAgentComponent } from '../AIDashboard/components/ai-agent/ai-agent.component';
import { ButtonModule } from 'primeng/button';
import { SharedCasePanelComponent } from './components/shared-case-panel/shared-case-panel.component';
import { SharedScreenStreamPanelComponent } from './components/shared-screen-stream-panel/shared-screen-stream-panel.component';
import { SharedHITLPanelComponent } from './components/shared-hitl-panel/shared-hitl-panel.component';
import { SharedAutomationPanelComponent } from './components/shared-automation-panel/shared-automation-panel.component';
import { IconInputWrapperComponent } from './components/formlyComponents/icon-input-wrapper/icon-input-wrapper.component';
import { AddressLocationComponent } from './components/address-location/address-location.component';
import { PatientDropdownComponent } from './components/patient-dropdown/patient-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        MultiSelectModule,
        InputSwitchModule,
        StepsModule,
        PanelMenuModule,
        SliderModule,
        BadgeModule,
        OpenbotsNgLibraryModule,
        NgxUploaderModule,
        DialogModule,
        SidebarModule,
        MatDialogModule,
        TableModule,
        // ToastrModule,
        InputTextareaModule,
        NgxJsonViewerModule,
        FormsModule,
        ReactiveFormsModule,
        JsonLogicEditorModule,
        FormlyPrimeNGModule,
        CardModule,
        DropdownModule,
        CheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        AccordionModule,
        MatDatepickerModule,
        MatIconModule,
        MatButtonModule,
        TreeModule,
        TabViewModule,
        ButtonModule,
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useValue: {
                    renderer: new ExtendedRenderer(),
                    gfm: true,
                    tables: false,
                    breaks: true,
                    pedantic: false,
                    sanitize: false,
                    smartLists: false,
                    smartypants: false,
                },
            },
        }),
        ConfirmDialogModule,
        AngularMarkdownEditorModule.forRoot({ iconlibrary: 'fa' }),
        FormlyModule.forRoot({
            validationMessages: [
                { name: 'required', message: 'This field is required' },
                // { name: 'type', message: typeValidationMessage },
                { name: 'minLength', message: minLengthValidationMessage },
                { name: 'maxLength', message: maxLengthValidationMessage },
                { name: 'min', message: minValidationMessage },
                { name: 'max', message: maxValidationMessage },
                { name: 'multipleOf', message: multipleOfValidationMessage },
                { name: 'exclusiveMinimum', message: exclusiveMinimumValidationMessage },
                {
                    name: 'exclusiveMaximum',
                    message: exclusiveMaximumValidationMessage,
                },
                { name: 'minItems', message: minItemsValidationMessage },
                { name: 'maxItems', message: maxItemsValidationMessage },
                {
                    name: 'uniqueItems',
                    message: 'should NOT have duplicate items',
                },
                { name: 'const', message: constValidationMessage },
            ],

            types: [
                // {name: 'Input', component: FormlyCaseInputComponent},
                { name: 'object', extends: 'formly-group' },
                { name: 'multischema', component: MultiSchemaTypeComponent },
                { name: 'array', component: ArrayTypeComponent },
                { name: 'string', component: FormlyInputComponent },
                // { name: 'Text', component: FormlyTextInputComponent},
                { name: 'json', component: FormlyJsonOutputComponent },
                // { name: 'checkbox', component: FormlyCheckboxComponent },
                //FormalyDatePicker
            ],
            wrappers: [
    { name: 'icon-input', component: IconInputWrapperComponent }
  ]
        }),
    ],
    declarations: [
        TextAreaCanvasComponent,
        ErrorMessageComponent,
        FileUploaderComponent,
        DeletePopupComponent,
        FileSizePipe,
        GroupByPipe,
        CastStatusPipe,
        MomentFormatPipe,
        UTCtoLocalTimeZonePipe,
        PhoneFormatPipe,
        TestingTableComponent,
        FormlyCaseInputComponent,
        AuthorizedDirective,
        TrimTextDirective,
        PositiveIntegerDirective,
        LazyImageDirective,
        MultiSchemaTypeComponent,
        ArrayTypeComponent,
        FormlyInputComponent,
        FormlyTextareaComponent,
        FormlyFileInputComponent,
        FormlyButtonComponent,
        // FormallySelectComponent,
        FormlyImageOutputComponent,
        FormlyTextOutputComponent,
        FormlyJsonOutputComponent,
        FormlyDatePickerComponent,
        PanelFieldWrapper,
        IconInputWrapperComponent,
        SeeMoreLessComponent,
        PermissionTreeComponent,
        CreateOrEditRoleModalComponent,
        NoAccessComponent,
        OrganizationBlockedComponent,
        CreateEditLibraryComponent,
        FormlyTextInputComponent,
        FormlyCheckboxComponent,
        PositiveIntegerDirective,
        ConfirmationDialogPopupComponent,
        UnsavedChangesModalComponent,
        PublishCommentsComponent,
        TemplateChecklistListComponent,
        SubscriptionWithErrorComponent,
        AiAgentComponent,
        SharedCasePanelComponent,
        SharedScreenStreamPanelComponent,
        SharedHITLPanelComponent,
        SharedAutomationPanelComponent,
        AddressLocationComponent,
        PatientDropdownComponent
    ],
    exports: [
        ConfirmDialogModule,
        AiAgentComponent,
        MatDialogModule,
        TextAreaCanvasComponent,
        StepsModule,
        PanelMenuModule,
        TableModule,
        SidebarModule,
        BadgeModule,
        MultiSelectModule,
        InputSwitchModule,
        SliderModule,
        FormlyModule,
        CardModule,
        FileSizePipe,
        CastStatusPipe,
        MomentFormatPipe,
        UTCtoLocalTimeZonePipe,
        PhoneFormatPipe,
        ErrorMessageComponent,
        FileUploaderComponent,
        DeletePopupComponent,
        NgxUploaderModule,
        OpenbotsNgLibraryModule,
        TooltipModule,
        MatDatepickerModule,
        MatInputModule,
        TestingTableComponent,
        FormlyCaseInputComponent,
        AuthorizedDirective,
        TrimTextDirective,
        LazyImageDirective,
        PositiveIntegerDirective,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        CheckboxModule,
        DropdownModule,
        ToastModule,
        // ToastrModule,
        TabViewModule,
        NgxJsonViewerModule,
        ArrayTypeComponent,
        FormlyInputComponent,
        DialogModule,
        MatDialogModule,
        AccordionModule,
        FormlyFileInputComponent,
        FormlyButtonComponent,
        // FormallySelectComponent,
        FormlyImageOutputComponent,
        FormlyTextOutputComponent,
        FormlyJsonOutputComponent,
        FormlyTextareaComponent,
        SeeMoreLessComponent,
        JsonLogicEditorModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        FormlyDatePickerComponent,
        TreeModule,
        PermissionTreeComponent,
        CreateOrEditRoleModalComponent,
        CreateEditLibraryComponent,
        NoAccessComponent,
        ConfirmationDialogPopupComponent,
        UnsavedChangesModalComponent,
        PublishCommentsComponent,
        TemplateChecklistListComponent,
        SharedCasePanelComponent,
        SharedScreenStreamPanelComponent,
        SharedHITLPanelComponent,
        SharedAutomationPanelComponent,
        AddressLocationComponent,
        PatientDropdownComponent,
        MatIconModule,
        MatButtonModule,
        ButtonModule
    ],

})
export class SharedModule { }
